import { EvtSelect } from "components/select";
import { getDirectusField } from "directus/src/operations";
import { useFetch } from "hooks/src/useFetch";
import React from "react";

const SelectColor = ({
  collection,
  className,
  value,
  onChange,
  placeholder,
  remove = [],
  ...props
}) => {
  const { data, isLoading, isError } = useFetch({
    queryKey: [collection, "colors"],
    queryFn: async () => {
      const response = await getDirectusField(collection, "color");

      const data = response.meta.options.choices.map((color) => {
        let name = color.text;
        return { name: name, id: color.value };
      });

      return data;
    },
    select: (data) =>
      remove?.length > 0
        ? data.filter((color) => !remove.includes(color.text))
        : data,
    enabled: !!collection,
  });

  return (
    <EvtSelect
      data={data}
      isLoading={isLoading}
      className={className}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      type="filter"
      {...props}
    />
  );
};

export default SelectColor;
